<div class="sidebar">
  <div class="sidebar__overlay" [ngClass]="{ on: showSideNav }" (click)="onSidebarClose()"></div>
  <div class="sidebar__navbar" [@slideInOut]="navState">
    <span class="close__icon" [ngClass]="{ show: showSideNav }" (click)="onSidebarClose()"
      ><i class="fal fa-times"></i
    ></span>
    <div class="sidebar__content">
      <div class="sidebar__menu show-menu" [@slideInLeft]="menuState">
        <a class="Body-Book home__icon" href="{{ homeNavigation?.externalUrl }}"
          ><i class="fas fa-home"></i> {{ homeNavigation?.title }}</a
        >
        <div class="sidebar__divider">
          <vm-divider-line></vm-divider-line>
        </div>
        <ul class="submenu" *ngFor="let menu of navigationData; let last = last">
          <li
            class="sidebar__content__list"
            *ngFor="let item of menu?.children"
            [attr.data-section]="item?.id"
            (click)="onClick(item)">
            <a class="Body-Book" href="{{ item?.externalUrl }}">
              <img [src]="contentBaseUrl + item?.icon?.url" alt="" width="24px" height="24px" />
              {{ item?.title }}
            </a>         
          </li>
          <li *ngIf="!last" class="sidebar__divider">
            <vm-divider-line></vm-divider-line>
          </li>   
        </ul>
      </div>
    </div>
  </div>
</div>
